"use client";
import React from "react";
import dynamic from "next/dynamic";

const Spline = dynamic(() => import("@splinetool/react-spline").then((mod) => mod.default), {
  ssr: false,
  loading: () => <div className="absolute inset-0 bg-black" />,
});

const SplineBackground: React.FC = () => {
  return (
    <div className="absolute inset-0">
      <Spline scene="https://prod.spline.design/jZ8AfXVqTdWsWCyQ/scene.splinecode" />
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-[30%] bg-gradient-to-t from-[#0e1016] via-[#0e1117]/70 to-transparent" />
    </div>
  );
};

export default SplineBackground;
